import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4953ed62")

_pushScopeId("data-v-4953ed62")
const _hoisted_1 = { class: "reportManager" }
const _hoisted_2 = { class: "report-list-assign-container" }
const _hoisted_3 = { class: "experimentModel" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = { class: "action flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "line mr8" }, null, -1)
const _hoisted_7 = { class: "page pr32" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, { items: [{name: "实验报告"}] }, {
      controllers: _withId(() => [
        _createVNode(_component_SvgIcon, {
          class: "my-icon",
          icon: "back",
          onClick: _ctx.back
        }, null, 8, ["onClick"])
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_a_table, {
            class: "teacher-list-table",
            "row-key": "id",
            pagination: false,
            loading: _ctx.tableLoading,
            "data-source": _ctx.tableList,
            columns: _ctx.columns
          }, {
            experimentModel: _withId(({record}) => [
              _createVNode("div", _hoisted_3, _toDisplayString(record.experimentModel === 1 ? '考核模式' : '自由练习'), 1)
            ]),
            status: _withId(({record}) => [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getStatus(record)), 1)
            ]),
            action: _withId(({record}) => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", {
                  class: ["text-btn pointer mr8", {'disabled-txt': _ctx.isEnd(record)}],
                  onClick: ($event: any) => (!_ctx.isEnd(record) && _ctx.gotoInfo(record))
                }, "查看报告", 10, ["onClick"]),
                _hoisted_6,
                _createVNode("div", {
                  class: ["text-btn pointer", {'disabled-txt': _ctx.isEnd(record)}],
                  onClick: ($event: any) => (!_ctx.isEnd(record) && _ctx.downLoad(record))
                }, "下载成绩", 10, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["loading", "data-source", "columns"]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_a_pagination, {
              current: _ctx.pageNo,
              "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageNo = $event)),
              pageSize: _ctx.pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageSize = $event)),
              total: _ctx.total,
              showSizeChanger: "",
              "show-quick-jumper": "",
              onChange: _ctx.pageChange,
              onShowSizeChange: _ctx.showSizeChange
            }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
})